import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import {
  RespCatalogInfo,
  RespCountries,
  RespObservationGps,
  RespRegions,
  RespSearch,
  RespVarietalGroups,
  Variedad,
  VarietyFilter,
} from "../model/variedad.model";
import { Observable } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class VariedadService {
  baseUrl = environment.baseUrl;
  constructor(private httpClient: HttpClient) { }
  varietyFilterList: VarietyFilter[] = [];

  addFilter(varietyFilter: VarietyFilter) {
    this.varietyFilterList.push(varietyFilter);
  }

  getFilters() {
    return this.varietyFilterList;
  }

  clearFilters() {
    this.varietyFilterList = [];
    return this.varietyFilterList;
  }

  get(id: string | number): Observable<Variedad> {
    return this.httpClient.get<Variedad>(`${this.baseUrl}variety/${id}`);
  }

  getAll(): Observable<Variedad> {
    return this.httpClient.get<Variedad>(
      `${this.baseUrl}variety?page_size=10000`
    );
  }


  getByDescriptor(descriptor_id: number): Observable<RespSearch> {
    const _route = "descriptor-category?";
    const _descriptor_id = "descriptor_id=" + descriptor_id;
    return this.httpClient.get<RespSearch>(
      `${this.baseUrl}${_route}${_descriptor_id}`
    );
  }

  getSearch(_var: {
    page: number | null;
    page_size: number | null;
    variety_name: string | null;
    country: string | null;
    region: string | null;
    varietal_group: string | null;
    original_only: boolean | null;
    is_original: boolean | null;
    user_id: number | null;
    created_date: string | null;
  }): Observable<RespSearch> {
    const _route = "variety/basic-filter?";
    const _page = "page=" + (_var.page ? _var.page + 1 : 1);
    const _page_size = "&page_size=" + (_var.page_size ? _var.page_size : 20);
    const _variety_name = _var.variety_name ? "&variety_name=" + _var.variety_name : "";
    const _country = _var.country ? "&country=" + _var.country : "";
    const _region = _var.region ? "&region=" + _var.region : "";
    const _varietal_group = _var.varietal_group ? "&varietal_group=" + _var.varietal_group : "";
    const _original_only = _var.original_only != null ? "&original_only=" + _var.original_only : "";
    const _is_original = _var.is_original != null ? "&is_original=" + _var.is_original : "";

    const _is_public = "&is_public=true";

    const _user = _var.user_id ? "&user_id=" + _var.user_id : "";
    const _created_date = _var.created_date ? "&created_date=" + _var.created_date : "";



    const url = this.baseUrl + _route + _page + _page_size + _variety_name + _country + _region + _varietal_group + _original_only + _is_public + _is_original + _user +
      _created_date;

    return this.httpClient.get<RespSearch>(
      `${url}`
    );
  }



  getAdminSearch(_var: {
    page: number | null;
    page_size: number | null;
    variety_name: string | null;
    country: string | null;
    region: string | null;
    varietal_group: string | null;
  }): Observable<RespSearch> {
    const _route = "variety/admin/basic-filter?";
    const _page = "page=" + (_var.page ? _var.page + 1 : 1);
    const _page_size = "&page_size=" + (_var.page_size ? _var.page_size : 20);
    const _variety_name = _var.variety_name
      ? "&variety_name=" + _var.variety_name
      : "";
    const _country = _var.country ? "&country=" + _var.country : "";
    const _region = _var.region ? "&region=" + _var.region : "";
    const _varietal_group = _var.varietal_group
      ? "&varietal_group=" + _var.varietal_group
      : "";
    return this.httpClient.get<RespSearch>(
      `${this.baseUrl}${_route}${_page}${_page_size}${_variety_name}${_country}${_region}${_varietal_group}`
    );
  }

  postAdvancedFilters(_var: {
    page: number | null;
    page_size: number | null;
    _filters: { filters: VarietyFilter[] };
  }): Observable<RespSearch> {
    const _route = "variety/advanced-filter?";
    const _page = _var.page ? _var.page + 1 : 1;
    const _page_size = _var.page_size ? _var.page_size : 20;

    return this.httpClient.post<RespSearch>(
      `${this.baseUrl}${_route}page=${_page}&page_size=${_page_size}`,
      _var._filters
    );
  }

  getCatalogInfo(id: string | number): Observable<RespCatalogInfo> {
    return this.httpClient.get<RespCatalogInfo>(
      `${this.baseUrl}variety/${id}/catalog-info`
    );
  }

  getObservationGps(id: number | string): Observable<RespObservationGps> {
    return this.httpClient.get<RespObservationGps>(
      `${this.baseUrl}variety/${id}/observations-gps`
    );
  }

  getCountries(): Observable<RespCountries> {
    const _route = "variety/countries?";
    const _is_public = "is_public=true";
    return this.httpClient.get<RespCountries>(`${this.baseUrl}${_route}${_is_public}`);
  }

  getRegions(country: string): Observable<RespRegions> {
    const _route = "variety/regions?";
    const _country = "country=" + country;
    return this.httpClient.get<RespRegions>(
      `${this.baseUrl}${_route}${_country}`
    );
  }

  getVarietalGroups(): Observable<any> {
    const _baseUrl = this.baseUrl;
    const _route = "variety/varietal-groups";
    const _url = _baseUrl + _route;
    return this.httpClient.get<any>(`${_url}`);
  }

  getToEditVariety(id: number | string): any {
    return this.httpClient.get<any>(`${this.baseUrl}variety/${id}`);
  }


  getVarietyNames(req: {
    variety_name: string | null,
    is_original: boolean | null,
    page: number | null,
    page_size: number | null
  }) {
    const _route = "variety/variety-names?";
    const _page = "&page=" + (req.page ? req.page : 1);
    const _page_size = "&page_size=" + (req.page_size ? req.page_size : 100);
    const _variety_name = "variety_name=" + req.variety_name;
    const _is_original = req.is_original != null ? "&is_original=" + req.is_original : "";

    return this.httpClient.get<any>(`${this.baseUrl}${_route}${_page}${_page_size}${_variety_name}${_is_original}`);
  }

  getVarietyDetail(id: string | number): Observable<any> {
    const _baseUrl = this.baseUrl;
    const _route = 'variety/';
    const _id = id;
    const _post_url = '/details'
    const _url = _baseUrl + _route + _id + _post_url;
    return this.httpClient.get<any>(`${_url}`);
  }

  getDescriptor(is_shared: boolean | null): Observable<any> {
    const _baseUrl = this.baseUrl;
    const _route = 'descriptor/filter?';
    const _is_shared = is_shared != null ? "is_shared=" + is_shared : "";
    const _url = _baseUrl + _route + _is_shared;
    return this.httpClient.get<any>(`${_url}`);
  }

  postVariety(body: any): Observable<any> {
    const _baseUrl = this.baseUrl;
    const _route = 'variety';
    const _url = _baseUrl + _route;
    return this.httpClient.post<any>(`${_url}`, body);
  }


}
